<template>
    <div>
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="hamtragch">
                        <swiper ref="mySwiper" :options="swiperOptions">
                            <swiper-slide :key="index" v-for="(hamt, index) in hamtragch">
                                <div class="hamtragch_item">
                                    <div class="hamtragch_item__logo">
                                        <Tooltip placement="top" max-width="300" :content="hamt.ner">
                                            <a target="_blank" :href="hamt.link">
                                                <img :src="hamt.logo" alt="">
                                            </a>
                                        </Tooltip>
                                    </div>
                                </div>
                            </swiper-slide>
                        </swiper>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    export default {
        name: 'slide',

        data () {
            return {
                hamtragch: [],
                swiperOptions: {
                    slidesPerView: 4,
                    spaceBetween: 15,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    breakpoints: {
                        1024: {
                            slidesPerView: 5,
                            spaceBetween: 20
                        },
                        768: {
                            slidesPerView: 4,
                            spaceBetween: 20
                        },
                        640: {
                            slidesPerView: 3,
                            spaceBetween: 15
                        },
                        414: {
                            slidesPerView: 2,
                            spaceBetween: 15
                        },
                        375: {
                            slidesPerView: 2,
                            spaceBetween: 15
                        },
                        320: {
                            slidesPerView: 1,
                            spaceBetween: 15
                        }
                    }
                }
            }
        },
        methods: {
        },
        mounted(){
            this.hamtragch = window.init.hamtragch;
            //console.log(this.hamtragch);
        },
    }
</script>
